import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { TRANSPORT_COST_PER_KM_GET } from 'api/query-keys.ts';
import type { TTransportCostPerKmRes } from 'api/swagger';

export const useGetTransportCostPerKm = () => {
  return useQuery<TTransportCostPerKmRes[]>({
    queryKey: [TRANSPORT_COST_PER_KM_GET],
    queryFn: async () => {
      const { data } = await http.get<TTransportCostPerKmRes[]>('/v1/transports/cost-per-km');
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
  });
};
